import Vue from 'vue';
import App from './App.vue'
import router from './router';
// import { Macro } from '.'

// Macro Demo
// Vue.use(Macro, { applicationName: "rmoneview" });

new Vue({
    el: "#app",
    router,
    render: h => h(App),
})